import { render, staticRenderFns } from "./map-darwer-change.vue?vue&type=template&id=147f507d&scoped=true&"
import script from "./map-darwer-change.vue?vue&type=script&lang=ts&"
export * from "./map-darwer-change.vue?vue&type=script&lang=ts&"
import style0 from "./map-darwer-change.vue?vue&type=style&index=0&id=147f507d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147f507d",
  null
  
)

export default component.exports